import React from 'react';
import { useEffectOnce } from 'react-use';

import { RHP } from 'providers';
import * as Alert from 'components/alert';
import * as List from 'components/list';
import * as Modal from 'components/modal';
import * as Page from 'components/page';
import * as Tabs from 'components/tabs';

import { Relationship, RelationshipCard } from '../components';

// Changed from step2 to step3

export function EcosystemStep3({ useRankingEcosystem, t }) {
    const { vars, updateSteps } = useRankingEcosystem;
    const { steps } = vars.application;

    const [modalData, setModalData] = React.useState(false);

    const relationships = vars.relationships.map(i => {
        const item = { ...i };
        item.onClick = () => setModalData(i);
        return item;
    });

    // Update the step has completed if relationships exist
    useEffectOnce(() => {
        if (vars.relationships && steps.step2 && !steps.step3) {
            updateSteps({ step3: true });
        }
    });

    // Check for previous step conclusion
    if (!steps || steps.step1 !== true) {
        RHP.replace('/ranking/latam/ecosystem/');
        return null;
    }

    const propsAlert = {
        title: t('EcosystemStep2.noRelationship'),
        descr: t('EcosystemStep2.noRelationshipDescr'),
        icons: 'far fa-exclamation-circle',
        buttn: {
            href: '/ranking/latam/ecosystem/step3/add',
            text: t('EcosystemStep2.addRelationship')
        },
        type: 'warning'
    };

    const pending = relationships
        .filter(i => i.status === 'pending')
        .sort((a, b) => {
            return new Date(b.regDate) - new Date(a.regDate);
        });

    const rejected = relationships
        .filter(i => i.status === 'rejected')
        .sort((a, b) => {
            return new Date(b.regDate) - new Date(a.regDate);
        });

    const confirmed = relationships
        .filter(i => i.status === 'confirmed')
        .sort((a, b) => {
            return new Date(b.regDate) - new Date(a.regDate);
        });

    return (
        <Page.Page
            name="EcosystemStep3"
            back="/ranking/latam/ecosystem"
            customBackText={t('glossary:backToRanking')}
        >
            <Page.Title>{t('EcosystemStep2.title')}</Page.Title>
            <Page.Descr>{t('EcosystemStep2.descr')}</Page.Descr>

            {relationships
                .filter(i => i.company.status === 'pending' && i.status === 'pending')
                .slice(0, 1)
                .map(i => {
                    const item = { ...i };
                    item.onClick = undefined;
                    return (
                        <Relationship
                            key={`pending-${i._id}`}
                            data={item}
                            useRankingEcosystem={useRankingEcosystem}
                        />
                    );
                })}
            {!vars.relationships.length && <Alert.Alert {...propsAlert} />}

            <Page.Buttn to="/ranking/latam/ecosystem/step3/add" type="linkd btn-block">
                <span className="icon far fa-plus-circle" aria-hidden="true" />
                <span className="text">{t('EcosystemStep2.addRelationship')}</span>
                <span className="icon far fa-long-arrow-right" aria-hidden="true" />
            </Page.Buttn>

            <Tabs.TabsContainer>
                <Tabs.TabsButtons>
                    <Tabs.Tab name="ES2C">
                        {t('glossary:confirmedBy.startup')}
                        {confirmed.length > 0 && <span>({confirmed.length})</span>}
                    </Tabs.Tab>
                    <Tabs.Tab name="ES2P">
                        {t('glossary:pending')}
                        {pending.length > 0 && <span>({pending.length})</span>}
                    </Tabs.Tab>
                    <Tabs.Tab name="ES2R">
                        {t('glossary:rejectedBy.startup')}
                        {rejected.length > 0 && <span>({rejected.length})</span>}
                    </Tabs.Tab>
                </Tabs.TabsButtons>

                <List.List name="ES2C">
                    <List.Vertical
                        items={confirmed}
                        itemKey="_id"
                        itemComponent={RelationshipCard}
                    />
                </List.List>
                <List.List name="ES2P">
                    <List.Vertical items={pending} itemKey="_id" itemComponent={RelationshipCard} />
                </List.List>
                <List.List name="ES2R">
                    <List.Vertical
                        items={rejected}
                        itemKey="_id"
                        itemComponent={RelationshipCard}
                    />
                </List.List>
            </Tabs.TabsContainer>

            <Page.Buttn to="/ranking/latam/ecosystem/step4">
                <span className="text">{t('glossary:continue')}</span>
                <span className="icon far fa-long-arrow-right" aria-hidden="true" />
            </Page.Buttn>

            <Modal.Modal
                close={() => setModalData(false)}
                title={t('EcosystemStep2.relationship')}
                isOpen={!!modalData}
            >
                {modalData && (
                    <Relationship
                        closeModal={() => setModalData(false)}
                        data={modalData}
                        style={{ marginTop: '1rem' }}
                        useRankingEcosystem={useRankingEcosystem}
                    />
                )}
            </Modal.Modal>
        </Page.Page>
    );
}

export default EcosystemStep3;
